import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 19217 17339"
    {...props}
  >
    <defs>
      <style>
        {/* {".str1{stroke:#1c1b17;stroke-width:212.588}.fil0{fill:#1c1b17}"} */}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974340249232">
        <path
          d="M9999 9051c-491 0-937 199-1259 520v2c-321 322-520 766-520 1256 0 491 199 935 520 1257v1c322 322 768 521 1259 521 490 0 934-199 1256-521h1c322-322 521-767 521-1258s-199-936-521-1258h-1c-322-321-766-520-1256-520z"
          className="fill stroke1"
          style={{
            stroke: "#1c1b17",
            strokeWidth: 1115.95,
          }}
          
        />
        <path
          d="M10898 106h-1c-569 0-1087 234-1463 609v1h-1c-375 376-609 894-609 1463v4613h2348V106h-274zM18825 16985l1-1 8-16c286-494 343-1060 206-1571-137-512-470-974-963-1258h-2l-3757-2170-236-136-136 236-900 1558-137 237 238 137 5314 3069 222 128 142-213zM255 15396l1 2 7 15c285 493 746 826 1259 963 512 137 1078 80 1572-206l3756-2169 237-136-136-236-900-1559-137-237-235 136-5315 3069-224 129 115 229z"
          className="fill stroke1"
          style={{
            strokeWidth: 212.588,
          }}
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
